export default {
  // 中文配置
  update_time_lower: '更新时间:',
  on_is_page: '在此页面',
  most_viewed_doc: '最受欢迎的内容',
  quick_access: '快速访问',
  tencent_games_in_game: 'Tencent Games InGame',

  documentation_portal: '文档中心',
  document_get_started: '快速接入',
  document_product: '产品概览',
  document_home_des:
    '在这里，能找到所有你想了解的内容，从文档中心开始，更快上手InGame',
  document_home_question: '如果您有任何问题，请随时 ',
  document_home_contact: '联系我们',
  get_started_des: '帮助你更快开始使用InGame',
  portal_manual_des: '控制台的基本信息',
  services_manual_des: 'InGame服务的用户使用指南，更多服务正在开发',
  tools_manual_des: '我们推荐技术开发人员在这里对SDK和工具有更深层次的理解',
  demo_tutorials_des: 'demo游戏的操作演示',
  knowledge_base_des: '总结了控制台配置内容中比较难以理解的部分',
  update_history_des: 'InGame的所有版本更新信息',

  services_manual_tips:
    '点击下面的任意模块以了解服务功能如何被运用在你的游戏中',
  multiplayer_content:
    '聚焦游戏后端核心能力，构建多人在线游戏生态，涵盖玩家管理、匹配、对战及自动化任务等在内的核心支撑能力',
  social_content:
    '打造游戏自己的社交圈层，让来自不同平台的玩家在游戏中进行互动交流，为玩家提供社交相关服务，如：好友管理、文本聊天、公会及排行榜等',
  economy_content:
    '构建长线运营商业生态，结合移动端丰富的研运经验和成熟的网游运营模式为游戏业务赋能',
  engage_content:
    '缩短游戏开发与玩家满意度之间的反馈回路，促进与玩家的联系，增强玩家粘性，以保持游戏的吸引力和趣味性',
  content_content:
    '打造全平台通用的内容分发技术，满足游戏GaaS化长线运营期的版本内容更新诉求',
  analytics_content:
    '构建数据分析监控体系，帮助用户进行游戏分析、性能监测，既能更进一步了解玩家并提供更有吸引力的体验，也同时可以确保游戏安全稳定运行，帮助决策制定',
  services_item_btn: '详情',
  content_no_per_first: '您暂无当前文档的查看权限',
  content_no_per_second_left: '如需查看，请先',
  content_no_per_second_right: 'InGame平台账号',
  content_no_per_second_login: '登录',
  search_results_total: '共{{total}}条搜索结果',
};
